import { render, staticRenderFns } from "./FunnelChart2.vue?vue&type=template&id=2119ae05&scoped=true&"
import script from "./FunnelChart2.vue?vue&type=script&lang=js&"
export * from "./FunnelChart2.vue?vue&type=script&lang=js&"
import style0 from "./FunnelChart2.vue?vue&type=style&index=0&id=2119ae05&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2119ae05",
  null
  
)

export default component.exports